class IPGStage {
  static DEV = 'DEV';
  static PROD = 'PROD';
}

export default IPGStage;
